import { useGetSummaryQuery } from '../../__generated__/chirp/com/hubspot/reviews/rpc/ReviewsRpc.hooks';
export function useAIReviewSummary({
  entityId,
  language,
  reviewType,
  skip
}) {
  const {
    data,
    loading,
    error
  } = useGetSummaryQuery({
    variables: {
      entityId,
      language,
      type: reviewType
    },
    skip
  });
  const reviewSummary = loading || error ? null : data === null || data === void 0 ? void 0 : data.summary;
  const reviewSummaryLastUpdated = loading || error ? null : data === null || data === void 0 ? void 0 : data.updatedAt;
  return {
    reviewSummary,
    reviewSummaryLastUpdated
  };
}